import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";

const SummaryReportITReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Summary Report - IT Report"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [summaryItReportData, setSummaryItReportData] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const columns = {
    Name: { text: "Category", align: "left", visible: true },
    AssetCount: { text: "Total", align: "center", visible: true },
    Allocated: { text: "Allocated", align: "center", visible: true },
    InStock: { text: "In Stock", align: "center", visible: true },
    Repairable: { text: "Repairable", align: "center", visible: true },
    Obselete: { text: "Obselete ", align: "center", visible: true },
    AssetPrice: { text: "Value ", align: "end", visible: true },
  };


 const ReadOnlyValues = [
    { label: " Total", value:`₹ ${ Number(grandTotal).toLocaleString("en-IN")}`},
  ]

  useEffect(() => {
    fetchGetSummaryReport();
  }, []);
    const [apiStatus, SetApiStatus] = useState(undefined);
    

  const fetchGetSummaryReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}support-desk-reports/6`
      );

      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setSummaryItReportData(cleanedData);
        setGrandTotal(response?.data?.total?.[0]?.Grandtotal);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Summary Report. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Summary Report:", error);
    }
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
        
          <div className="row mt-2">
            <Dynamic_PR_table
              data={summaryItReportData}
              columns={columns}
              ReadOnlyValues={ReadOnlyValues}
              itemsPerPage={10}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              showIcon1={true}
              showIcon2={false}
              isActionRequired={false}
              isAddNewBtnRequired={false}
              showIcon3={false}
              showIcon4={false}
              showIcon5={false}
              // handleIcon1={handleEdit}
              // handleAddNew={handleAddNewVendor}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SummaryReportITReport;
